import gql from 'graphql-tag'

export const repliesTranslations = gql`
query repliesTranslationsV2($lang: String, $repliesIds: [Int]!) {
  repliesTranslationsV2(lang: $lang, repliesIds: $repliesIds) {
    replyId
    text
  }
}
`
export const repliesTranslationsV1 = gql`
query repliesTranslations($lang: String, $repliesIds: [Int]!) {
  repliesTranslations(lang: $lang, repliesIds: $repliesIds) {
    replyId
    text
  }
}
`